export function formatDate (date) {
  // Format 2020-04-30
  return [
    date.getFullYear(),
    ('0' + String(date.getMonth() + 1)).slice(-2),
    ('0' + String(date.getDate())).slice(-2)
  ].join('-')
}

export function getMonth (date) {
  return Intl.DateTimeFormat('en-us', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC'
  }).format(new Date(date))
}

export function getEndOfMonthDate () {
  const today = new Date()
  const year = today.getFullYear()
  const month = today.getMonth()

  return new Date(year, month + 1, 0)
}

export function addDateDays (date, days) {
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    (date.getDate() + days)
  )
}

export function subtractDateDays (date, days) {
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    (date.getDate() - days)
  )
}

export function getDateInWorkingTimeZone () {
  return new Date((new Date()).toLocaleString('lv-LV', { timeZone: 'Europe/Riga' }))
}

export function dateToFileName (date = new Date()) {
  if (date instanceof Date) {
    return date.toISOString()
      .replace('T', '_')
      .replace('.', '_')
      .replaceAll(':', '-')
  }
}

export function getCurrentDateString () {
  return formatDate(new Date())
}

export function getCurrentDate () {
  return new Date(getCurrentDateString())
}
